export const BaseDict = {
    scores: "Scores",
    games: "Matches",
    incidents: "Incidents",
    startedAt: "Started Today at"
};
//# sourceMappingURL=dict.js.map